/**
 * OPEN-220a / DEC-386 — "Automatic" on an arrival the phone's geofence recorded.
 *
 * The API returns a job event's `triggeredBy` from job_events.payload.triggered_by (OPEN-211):
 * MANUAL (the driver tapped Arrived) or GEOFENCE_AUTO (the phone marked it after the dwell).
 * Events from before OPEN-211 have null and show nothing extra. A timeclock row's triggeredBy
 * is a different vocabulary (DRIVER, SYSTEM, …) and keeps its old use as the fallback name.
 */

export const AUTOMATIC_ARRIVAL_LABEL = 'Automatic';

const ARRIVAL_EVENT_TYPES: ReadonlySet<string> = new Set(['ARRIVED_PICKUP', 'ARRIVED_DISPOSAL']);

/** The tap-or-geofence tags: never shown as a person's name. */
const ARRIVAL_TRIGGERS: ReadonlySet<string> = new Set(['MANUAL', 'GEOFENCE_AUTO']);

interface TriggeredEvent {
  readonly eventType: string;
  readonly actorName: string | null;
  readonly triggeredBy: string | null;
}

/** Did the phone's geofence record this arrival? */
export function isAutomaticArrival(e: Pick<TriggeredEvent, 'eventType' | 'triggeredBy'>): boolean {
  return ARRIVAL_EVENT_TYPES.has(e.eventType) && e.triggeredBy === 'GEOFENCE_AUTO';
}

/**
 * Who a timeline row names: the actor, else a timeclock trigger, else System; with
 * " · Automatic" after an automatic arrival.
 */
export function eventWhoLabel(e: TriggeredEvent): string {
  const trigger =
    e.triggeredBy !== null && !ARRIVAL_TRIGGERS.has(e.triggeredBy) ? e.triggeredBy : null;
  const who = e.actorName ?? trigger ?? 'System';
  return isAutomaticArrival(e) ? `${who} · ${AUTOMATIC_ARRIVAL_LABEL}` : who;
}
